<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> added the webhook, which was added by-->
<!--        <strong>{{ $_.get(activity, "payload.name") }}</strong>.-->
<!--        Kontrol Edilecek-->
        <span v-html="$t('notification.webhookAdded', { user1: $_.get(activity, 'actorUser.name'), user2:$_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WebhookAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
